import { motionValue } from "framer-motion";

// Shared, app-wide pointer position (normalized -0.5..0.5), updated once.
export const pointerX = motionValue(0);
export const pointerY = motionValue(0);

if (typeof window !== "undefined" && !window.__tojiParallax) {
  window.__tojiParallax = true;
  window.addEventListener(
    "pointermove",
    (e) => {
      pointerX.set(e.clientX / window.innerWidth - 0.5);
      pointerY.set(e.clientY / window.innerHeight - 0.5);
    },
    { passive: true }
  );
  window.addEventListener(
    "deviceorientation",
    (e) => {
      if (e.gamma == null || e.beta == null) return;
      pointerX.set(Math.max(-0.5, Math.min(0.5, e.gamma / 60)));
      pointerY.set(Math.max(-0.5, Math.min(0.5, (e.beta - 45) / 60)));
    },
    true
  );
}
